import Dashboard from "../../pages/dashboard/Dashboard";
import AuthPage from "../../pages/auth/AuthPage";
import NotFound from "../main/NotFound";
import Predictions from "pages/predictions/Predictions";
import Prediction from "pages/predictions/Prediction";
import ManagePrediction from "pages/predictions/manage/ManagePrediction";
import Surveys from "pages/surveys/Surveys";
import Survey from "pages/surveys/Survey";
import ManageSurvey from "pages/surveys/manage/ManageSurvey";
import Predictors from "pages/predictors/Predictors";
import Predictor from "pages/predictors/Predictor";
import ManagePredictor from "pages/predictors/manage/ManagePredictor";
import Profile from "pages/profile/Profile";
import Main from "pages/main/Main";
import Promises from "pages/promises/Promises";
import PromisePage from "pages/promises/PromisePage";
import ManagePromise from "pages/promises/manage/ManagePromise";
import News from "pages/news/News";
import AutomationsPage from "pages/automations/AutomationsPage";

export const protectedRoutes = [
  { path: "/", element: <Dashboard /> },
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/profile", element: <Profile /> },
  { path: "/profile/:id", element: <Profile /> },
  { path: "/predictions", element: <Predictions /> },
  { path: "/predictions/:id", element: <Prediction isEditable={false} /> },
  {
    path: "/predictions/manage",
    element: <ManagePrediction isEditable={true} />,
  },
  {
    path: "/predictions/manage/:id",
    element: <ManagePrediction isEditable={true} />,
  },

  { path: "/promises", element: <Promises /> },
  { path: "/promises/:id", element: <PromisePage isEditable={false} /> },
  {
    path: "/promises/manage",
    element: <ManagePromise isEditable={true} />,
  },
  {
    path: "/promises/manage/:id",
    element: <ManagePromise isEditable={true} />,
  },

  { path: "/surveys", element: <Surveys /> },
  { path: "/surveys/:id", element: <Survey isEditable={false} /> },
  {
    path: "/surveys/manage",
    element: <ManageSurvey isEditable={true} />,
  },
  {
    path: "/surveys/manage/:id",
    element: <ManageSurvey isEditable={true} />,
  },

  { path: "/predictors", element: <Predictors /> },
  { path: "/predictors/:id", element: <Predictor isEditable={false} /> },
  {
    path: "/predictors/manage",
    element: <ManagePredictor isEditable={true} />,
  },
  {
    path: "/predictors/manage/:id",
    element: <ManagePredictor isEditable={true} />,
  },
  { path: "/main", element: <Main /> },
  { path: "/news", element: <News /> },
  { path: "/automations", element: <AutomationsPage /> },
  { path: "*", element: <NotFound /> },
];

export const routes = [
  { path: "/auth", element: <AuthPage /> },
  { path: "*", element: <NotFound /> },
];
